export default __webpack_public_path__ + "static/5_17-9057fb35da596f6178f08d8c5501d23d.png";